"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailOrNull = exports.strOrNull = exports.numOrNull = exports.dateLike = exports.paginationSchema = exports.contactNameSchema = exports.nameSchema = exports.addressSchema = exports.jdeCodeSchema = exports.objectIdSchema = void 0;
const zod_1 = require("zod");
exports.objectIdSchema = zod_1.z.string().regex(/^[0-9a-fA-F]{24}$/, 'Invalid ObjectId');
/** A JDE code (customer address-book code or item number) as Weightrax holds
 *  it in JDE_CUSTOMER_CODE / JDE_MATERIAL_CODE. Upper-cased; JDE item numbers
 *  are at most 25 characters. */
exports.jdeCodeSchema = zod_1.z.string().trim().toUpperCase()
    .regex(/^[A-Z0-9][A-Z0-9./-]{0,24}$/, 'JDE code: letters, digits, "-", "/" or "." only, max 25 characters');
exports.addressSchema = zod_1.z.object({
    addressLine1: zod_1.z.string().optional(),
    addressLine2: zod_1.z.string().optional(),
    city: zod_1.z.string().optional(),
    stateProvince: zod_1.z.string().optional(),
    postalCode: zod_1.z.string().optional(),
    country: zod_1.z.string().optional(),
    latitude: zod_1.z.number().nullable().optional(),
    longitude: zod_1.z.number().nullable().optional(),
}).nullable().optional();
exports.nameSchema = zod_1.z.object({
    prefix: zod_1.z.string().optional(),
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    suffix: zod_1.z.string().optional(),
}).nullable().optional();
// Backwards-compat alias used by master-data schemas
exports.contactNameSchema = exports.nameSchema;
exports.paginationSchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    limit: zod_1.z.coerce.number().int().min(1).max(500).default(25),
    search: zod_1.z.string().optional(),
    sort: zod_1.z.string().optional(),
});
exports.dateLike = zod_1.z.union([zod_1.z.string().datetime(), zod_1.z.string().min(1), zod_1.z.date()]).nullable().optional();
exports.numOrNull = zod_1.z.number().nullable().optional();
exports.strOrNull = zod_1.z.string().nullable().optional();
exports.emailOrNull = zod_1.z.union([zod_1.z.string().email(), zod_1.z.literal('')]).nullable().optional();
//# sourceMappingURL=common.js.map